/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    //"aws_cognito_identity_pool_id": "us-east-1:ef4bf2cb-df86-4999-87e7-6a8ebcfb270f",
    "aws_cognito_identity_pool_id": "us-east-1:52520067-ebf2-44b5-80e9-2f15b76777bf",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_5ncXmpjbJ",
    "aws_user_pools_web_client_id": "cpcu3sqp6oeppuj3v6qrvq62a",
    "oauth": {},
    "aws_cognito_login_mechanisms": [
        "EMAIL"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
